import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import ProductSection from "./ThirdVarient";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data, variant_type } from "../../../utils/common";

const DoubleVarient = ({
  clearErrors,
  useWatch,
  setError,
  singleIndex,
  tripleIndex,
  control,
  register,
  getValues,
  errors,
  setValue,
  variantType,
}) => {
  const { fields, append, remove, watch } = useFieldArray({
    control,
    name: `variants.${singleIndex}.double_variants`,
  });

  const [Sizes, setSize] = useState([]);
  const getAllSize = async () => {
    const response = await getData(`/common/masters/all-size`);
    if (response?.success) {
      setSize(await Select2Data(response?.data, "size_id"));
    }
  };

  useEffect(() => {
    getAllSize();
  }, []);

  // const DoubleVariantPriceCalculator = ({ singleIndex, deliveryIndex, control, setValue }) => {
  //   const mrp = useWatch({
  //     control,
  //     name: `variants.${singleIndex}.double_variants.${deliveryIndex}.mrp`,
  //   });

  //   const discount = useWatch({
  //     control,
  //     name: `discount_percentage`,
  //   });

  //   useEffect(() => {
  //     const mrpNum = parseFloat(mrp);
  //     const discountNum = parseFloat(discount);

  //     if (!mrpNum) {
  //       setValue(`variants.${singleIndex}.double_variants.${deliveryIndex}.price`, "");
  //       return;
  //     }

  //     if (!discount) {
  //       setValue(
  //         `variants.${singleIndex}.double_variants.${deliveryIndex}.price`,
  //         mrpNum.toFixed(2)
  //       );
  //       return;
  //     }

  //     const price = mrpNum - (mrpNum * discountNum) / 100;

  //     setValue(
  //       `variants.${singleIndex}.double_variants.${deliveryIndex}.price`,
  //       price.toFixed(2)
  //     );
  //   }, [mrp, discount, singleIndex, deliveryIndex, setValue]);

  //   return null;
  // };

  // const VariantPriceCalculator = ({
  //   type, // "double" or "triple"
  //   singleIndex, // parent index
  //   childIndex, // double or triple index
  //   control,
  //   setValue,
  // }) => {
  //   const basePath = `variants.${singleIndex}.${type}_variants.${childIndex}`;

  //   const mrp = useWatch({
  //     control,
  //     name: `${basePath}.mrp`,
  //   });

  //   const discount = useWatch({
  //     control,
  //     name: `discount_percentage`,
  //   });

  //   useEffect(() => {
  //     const mrpNum = parseFloat(mrp);
  //     const discountNum = parseFloat(discount);

  //     if (!mrpNum) {
  //       setValue(`${basePath}.price`, "");
  //       return;
  //     }

  //     if (!discount) {
  //       setValue(`${basePath}.price`, mrpNum.toFixed(2));
  //       return;
  //     }

  //     const price = mrpNum - (mrpNum * discountNum) / 100;

  //     setValue(`${basePath}.price`, price.toFixed(2));
  //   }, [mrp, discount, basePath, setValue]);

  //   return null;
  // };

  const [variantsError, setVariantsError] = useState("");

  useEffect(() => {
    register(`variants.${singleIndex}.double_variants`, {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setVariantsError(isValid ? "" : "At least one size is required");
        return isValid;
      },
    });
  }, [register]);
  return (
    <>
      {variantsError && <span className="text-danger">{variantsError}</span>}
      {fields.map((delivery, deliveryIndex) => (
        <div key={delivery.id} className="border p-3 mb-3">
          <Row className="mb-3">
            <h5>
              Pack of
              {/* of {deliveryIndex + 1} */}
            </h5>

            <Col md={4} className="mb-1">
              <Form.Group>
                <Form.Label>Pack of</Form.Label>
                <Controller
                  control={control}
                  name={`variants.${singleIndex}.double_variants.${deliveryIndex}.size_id`}
                  rules={{
                    required: "Enter Pack of",
                  }}
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Pack of"
                      onChange={(e) => onChange(e.target.value)}
                      onBlur={onBlur}
                      value={value || ""}
                      ref={ref}
                      style={{
                        borderColor: errors?.variants?.[singleIndex]
                          ?.double_variants?.[deliveryIndex]?.size_id
                          ? "red"
                          : undefined,
                      }}
                    />
                  )}
                />

                {errors?.variants?.[singleIndex]?.double_variants?.[
                  deliveryIndex
                ]?.size_id && (
                  <span className="text-danger">
                    {
                      errors.variants[singleIndex].double_variants[
                        deliveryIndex
                      ].size_id.message
                    }
                  </span>
                )}
              </Form.Group>
            </Col>
            {Number(variantType?.value) === Number(variant_type.Double) && (
              <>
                {" "}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>MRP</Form.Label>
                    <Form.Control
                      type="text"
                      {...register(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.mrp`,
                        {
                          required: "MRP required",
                        },
                      )}
                      onKeyDown={(e) => {
                        // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                        if (
                          !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "."
                        ) {
                          e.preventDefault(); // Prevent the event if it's not allowed
                        }

                        // Prevent entering more than one decimal point
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors?.variants?.[singleIndex]?.double_variants?.[
                      deliveryIndex
                    ]?.mrp && (
                      <span className="text-danger">
                        {
                          errors.variants[singleIndex].double_variants[
                            deliveryIndex
                          ].mrp.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Col>
                {/* <DoubleVariantPriceCalculator
                  singleIndex={singleIndex}
                  deliveryIndex={deliveryIndex}
                  control={control}
                  setValue={setValue}
                /> */}
                {/* <VariantPriceCalculator
                  type="double"
                  singleIndex={singleIndex}
                  childIndex={deliveryIndex}
                  control={control}
                  setValue={setValue}
                /> */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Price</Form.Label>
                    <Form.Control
                      type="text"
                      // readOnly
                      // disabled
                      {...register(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.price`,
                        {
                          required: "Price required",

                          validate: (value) => {
                            const mrp = getValues(
                              `variants.${singleIndex}.double_variants.${deliveryIndex}.mrp`,
                            );

                            if (mrp && Number(value) > Number(mrp)) {
                              return "Price cannot be greater than MRP";
                            }
                            return true;
                          },
                        },
                      )}
                      onKeyDown={(e) => {
                        // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                        if (
                          !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "."
                        ) {
                          e.preventDefault(); // Prevent the event if it's not allowed
                        }

                        // Prevent entering more than one decimal point
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors?.variants?.[singleIndex]?.double_variants?.[
                      deliveryIndex
                    ]?.price && (
                      <span className="text-danger">
                        {
                          errors.variants[singleIndex].double_variants[
                            deliveryIndex
                          ].price.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Col>
                {/* <Col md={4}>
                  <Form.Group>
                    <Form.Label>Price</Form.Label>
                    <Form.Control
                      type="text"
                      {...register(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.price`,
                        {
                          required: "Price required",
                          validate: (value) => {
                            const mrp = getValues(
                              `variants.${singleIndex}.double_variants.${deliveryIndex}.mrp`
                            );
                            if (mrp && Number(value) > Number(mrp)) {
                              return "Price cannot be greater than MRP";
                            }
                            return true;
                          },
                        }
                      )}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "."
                        ) {
                          e.preventDefault();
                        }
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]?.price && (
                      <span className="text-danger">
                        {
                          errors.variants[singleIndex].double_variants[deliveryIndex].price
                            .message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Col> */}
              </>
            )}
          </Row>
          {Number(variantType?.value) === Number(variant_type.Triple) && (
            <ProductSection
              useWatch={useWatch}
              clearErrors={clearErrors}
              setError={setError}
              singleIndex={singleIndex}
              deliveryIndex={deliveryIndex}
              control={control}
              register={register}
              getValues={getValues}
              errors={errors}
              setValue={setValue}
            />
          )}

          <button
            type="button"
            className="btn btn-danger "
            onClick={() => remove(deliveryIndex)}
          >
            Remove Pack of
          </button>
        </div>
      ))}

      <div className="text-center">
        <button
          type="button"
          className="btn btn-secondary me-2 w-auto"
          onClick={() => append({ triple_variants: [] })}
        >
          + Add Pack of
        </button>
      </div>
    </>
  );
};

export default DoubleVarient;
